<script setup lang="ts">
import { iconBtnSize } from '@/constants/vSettings.constants'

const { items, readonly, route, prepareTitle } = defineProps<{
  items: Array<any>,
  readonly?: boolean
  route?: string
  prepareTitle?:(item: any) => string
}>()

const emit = defineEmits(['removeItem'])
const removeItem = (item: unknown) => emit('removeItem', item)

const getPrepareTitle = (item: any) => {
  if (prepareTitle && typeof prepareTitle === 'function') {
    return prepareTitle(item)
  }

  return item.title || item.Title || item.Name
}
</script>

<template>
  <VList
    lines="one"
    density="compact"
    class="py-0"
  >
    <VListItem
      v-for="item in items"
      :key="item.Uuid || item.Bundle?.Uuid"
      class="px-0"
    >
      <div class="d-flex align-center border-b p-0">
        <RouterLink
          v-if="route && ( item.Uuid || item.Bundle?.Uuid )"
          :to="{name: route, params: { uuid: item.Uuid || item.Bundle.Uuid }}"
          :target="readonly ? undefined : '_blank'"
        >
          {{ getPrepareTitle(item) }}
        </RouterLink>

        <template v-else>
          {{ getPrepareTitle(item) }}
        </template>

        <VIconBtn
          v-if="!readonly"
          class="ml-auto"
          icon="mdi-close"
          variant="text"
          color="error"
          :size="iconBtnSize"
          @click="removeItem(item)"
        />
      </div>
    </VListItem>
  </VList>
</template>
